import { Inject, Injectable } from '@angular/core';
import { PortalRegister } from '../model/portal-register';
import { ConfigService } from './config.service';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BasicResponse, PortalNotification } from '../..';

export interface PortalRegisterAPI {
  items: PortalRegister[];
  total_count: number;
}

export interface PortalRegisterListAPI {
  portals: PortalRegister[];
}

export interface PortalNotificationAPI {
  items: PortalNotification[];
  total_count: number;
}
@Injectable({
  providedIn: 'root',
})
export class PortalRegisterService {
  constructor(
    @Inject(ConfigService) private config: any,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find(
        (restUrl: { api: string }) => restUrl.api === 'PADM'
      ).url;
    this.headers = new HttpHeaders().set('DoNotIntercept', 'true');
  }
  private URL;
  headers: HttpHeaders;

  private static handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // return an observable with a user-facing error message
    // return throwError('Something bad happened; please try again later.');
    return throwError(error);
  }

  getPortalRegisters(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string
  ): Observable<PortalRegisterAPI> {
    const headers = this.headers;
    if (sortActive === '' || sort === '') {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient
      .get<PortalRegisterAPI>(
        `${this.URL}/portal/portalregister/${pageIndex}/${pageSize}/${sortActive}/${sort}`,
        { headers }
      )
      .pipe(catchError(PortalRegisterService.handleError));
  }

  getPortalRegisterList(): Observable<PortalRegisterListAPI> {
    const headers = this.headers;

    return this.httpClient
      .get<PortalRegisterListAPI>(`${this.URL}/portal/portalregister/`, {
        headers,
      })
      .pipe(catchError(PortalRegisterService.handleError));
  }

  getPortalNotifications(
    portalid: number,
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string
  ): Observable<PortalNotificationAPI> {
    const headers = this.headers;
    if (sortActive === '' || sort === '') {
      sortActive = '0';
      sort = 'asc';
    }
    return this.httpClient
      .get<PortalNotificationAPI>(
        `${this.URL}/portal/portalregister/${portalid}/notification/${pageIndex}/${pageSize}/${sortActive}/${sort}`,
        { headers }
      )
      .pipe(catchError(PortalRegisterService.handleError));
  }

  savePortalNotification(
    portalNotification: PortalNotification
  ): Observable<BasicResponse> {
    portalNotification.id = portalNotification.id.toString();
    const headers = this.headers;
    return this.httpClient
      .put<BasicResponse>(
        `${this.URL}/portal/portalregister/notification`,
        portalNotification,
        { headers }
      )
      .pipe(catchError(PortalRegisterService.handleError));
  }

  savePortalRegister(
    portalRegister: PortalRegister
  ): Observable<PortalRegister> {
    const headers = this.headers;
    return this.httpClient
      .put<PortalRegister>(
        `${this.URL}/portal/portalregister/`,
        portalRegister,
        { headers }
      )
      .pipe(catchError(PortalRegisterService.handleError));
  }

  updatePortalRegister(
    portalRegister: PortalRegister
  ): Observable<BasicResponse> {
    const headers = this.headers;
    return this.httpClient.put<BasicResponse>(
      `${this.URL}/portal/portalregister/${portalRegister.id}`,
      portalRegister,
      { headers }
    );
  }
}
